import { motion } from "framer-motion";
import { ShieldCheck, MapPin, HeartHandshake, Zap, BadgeEuro } from "lucide-react";

const POINTS = [
  {
    icon: ShieldCheck,
    title: "Zuverlässig & Professionell",
    desc: "Qualität, auf die Sie sich verlassen können.",
  },
  {
    icon: MapPin,
    title: "Regionales Unternehmen",
    desc: "Für unsere Kunden in Ihrer Nähe – in Gronau (Westf.) und Umgebung.",
  },
  {
    icon: HeartHandshake,
    title: "Kundenorientiert",
    desc: "Ihre Zufriedenheit steht bei uns an erster Stelle.",
  },
  {
    icon: Zap,
    title: "Schnell, Sicher & Effizient",
    desc: "Termingerecht und reibungslose Abläufe.",
  },
  {
    icon: BadgeEuro,
    title: "Faire Preise",
    desc: "Transparente Preise ohne versteckte Kosten.",
  },
];

export const WhyUs = () => (
  <section id="warum-wir" data-testid="why-us-section" className="bg-ink py-24 md:py-36">
    <div className="mx-auto max-w-7xl px-5 md:px-8">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mb-16 md:mb-20 flex flex-col md:flex-row md:items-end md:justify-between gap-6"
      >
        <div>
          <p className="mb-4 text-xs font-bold tracking-[0.3em] text-brand-bright">WARUM TERBECK SERVICE?</p>
          <h2 className="font-display text-4xl md:text-6xl font-bold uppercase tracking-tighter text-white leading-[1.02]">
            Fünf Gründe.<br />
            <span className="text-white/40">Ein Versprechen.</span>
          </h2>
        </div>
        <p className="max-w-sm text-sm md:text-base leading-relaxed text-white/50">
          Was unsere Kunden schätzen: Verlässlichkeit, Nähe und ein Service, der hält, was er verspricht.
        </p>
      </motion.div>

      <div>
        {POINTS.map((p, i) => {
          const Icon = p.icon;
          return (
            <motion.div
              key={p.title}
              data-testid={`why-us-item-${i + 1}`}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.55, delay: i * 0.06 }}
              className="group relative flex items-center gap-6 md:gap-12 border-t border-white/10 py-8 md:py-10 last:border-b transition-colors duration-500 hover:bg-white/[0.02]"
            >
              <span className="font-display text-4xl md:text-6xl font-extrabold text-white/10 transition-colors duration-500 group-hover:text-brand/40 w-16 md:w-28 shrink-0">
                0{i + 1}
              </span>
              <span className="hidden sm:inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-brand/10 text-brand-bright ring-1 ring-brand/30 transition-colors duration-500 group-hover:bg-brand group-hover:text-black">
                <Icon className="h-6 w-6" strokeWidth={1.75} />
              </span>
              <div className="flex min-w-0 flex-col lg:flex-row lg:items-center lg:justify-between gap-1 lg:gap-8 flex-1">
                <h3 className="font-display text-xl md:text-2xl lg:text-3xl font-bold uppercase tracking-tight text-white">
                  {p.title}
                </h3>
                <p className="text-sm md:text-base text-white/55 lg:max-w-xs lg:text-right">{p.desc}</p>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);
